import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Commesse } from '@/pages/commesse';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { useTenantFeatureFlags } from '@/lib/hooks/use-tenant-feature-flags';
import z from '@/lib/zod';
import { optionalSearchString } from '@/lib/zod-search-params';

export const commesseSearchSchema = commonSearchSchema.extend({
  subTab: z.string().nullish(),
  /** Popover «Filtri»: cliente committente. */
  companyId: optionalSearchString(),
});

export const Route = createFileRoute('/protected/_layout/commesse/_layout')({
  validateSearch: commesseSearchSchema,
  component: CommesseLayout,
});

/**
 * Commesse visibili con il permesso E il feature flag del tenant
 * (`commesseEnabled`, spento di default): in local/dev si accende da Dev
 * tools, in produzione dal backoffice. Il guard copre anche index/new/$id.
 */
function CommesseLayout() {
  const { canAccessCommesse, isLoading } = usePermissions();
  const { isCommesseEnabled, isLoading: isLoadingFlags } =
    useTenantFeatureFlags();

  return (
    <RoleGuard
      hasAccess={canAccessCommesse && isCommesseEnabled}
      isLoading={isLoading || isLoadingFlags}
    >
      <Commesse />
      <Outlet />
    </RoleGuard>
  );
}
